
import { Component, Mixins } from 'vue-property-decorator';
import { toast } from '@/utils/common';
import { PageQuery } from '@/mixins/page_query';
// eslint-disable-next-line no-unused-vars
import { iGift, iGiftSearch, iGiftSort } from '@/interface/gift';
import { createGift, listGift, sortGift, statusGift, updateGift } from '@/api/gift';
import EditGift from './edit.vue';
import { iUploadeImagesList } from '@/interface/imageUpload';
import { configKindOptions } from './config';
@Component({
  components: {
    EditGift,
  },
  filters: {
    kindLable(_kind: number) {
      const kinds = [{ label: '全部', value: 0 }, ...configKindOptions];
      const kind = kinds.find(item => item.value === _kind);
      return kind ? kind.label : '未知类型';
    },
    priceLabel(item: iGift) {
      const kindId = item.kind;
      let _priceLabel: string = '';
      switch (kindId) {
        case 1:
          _priceLabel = '冷却时间' + item.kind1.cooling + '秒,最多累积' + item.kind1.max + '个';
          break;
        case 2:
          _priceLabel = '-';
          break;
        case 3:
          _priceLabel = item.kind3.coin + '云币';
          break;
        case 4:
          _priceLabel = '周期卡' + item.kind4.duration + '分钟(有效期' + item.kind4.expire + '天)';
          break;
      }
      return _priceLabel;
    },
    costLabel(item: iGift) {
      const kindId = item.kind;
      let _costLabel: string = '';
      switch (kindId) {
        case 1:
          _costLabel = '免费';
          break;
        case 2:
          _costLabel = item.kind2.price + '云朵';
          break;
        case 3:
          _costLabel = item.kind3.price + '云朵';
          break;
        case 4:
          _costLabel = item.kind4.price + '云朵';
          break;
      }
      return _costLabel;
    },
  },
})
export default class GiftList extends Mixins(PageQuery) {
  list: iGift[] = [];
  total: number = 0;
  loading: boolean = false;
  showDialog: boolean = false;
  staticImgUpload: iUploadeImagesList[] = [];
  dynamicImgUpload: iUploadeImagesList[] = [];
  empityModel: string =
    '{"name":"","kind":1,"hots":"","desc":"","enable":true,"img_s":"","img_d":"","kind1":{"cooling":1,"max":5},"kind2":{"price":0},"kind3":{"coin":0,"price":0},"kind4":{"duration":0,"expire":0,"price":0}}';
  giftFormData: iGift = JSON.parse(this.empityModel);

  kindOptions: Array<{ label: string; value: number }> = [{ label: '全部', value: 0 }, ...configKindOptions];
  statusOptions: { label: string; value: number }[] = [
    { label: '全部', value: 0 },
    { label: '启用', value: 1 },
    { label: '禁用', value: 2 },
  ];
  searchInfo: iGiftSearch = {
    id: '',
    name: '',
    kind: 0,
    enable: 0,
  };

  private showCreateGift() {
    this.giftFormData = JSON.parse(this.empityModel);
    this.staticImgUpload = [];
    this.dynamicImgUpload = [];
    this.showDialog = true;
  }

  private onSearch() {
    this.page_query.page = 1;
    this.getList();
  }

  private changeGiftStatus(item: iGift) {
    if (!item.enable) {
      this.$confirm('请问您确定要禁用该礼物吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          item.enable = false;
          statusGift({ id: Number(item.id), enable: item.enable }).then(() => {
            this.getList();
          });
        })
        .catch(() => {
          item.enable = true;
        });
    } else {
      statusGift({ id: Number(item.id), enable: item.enable }).then(() => {
        this.getList();
      });
    }
  }

  showEditGift(item: iGift) {
    this.giftFormData = item;
    this.staticImgUpload = [];
    this.dynamicImgUpload = [];
    if (item.img_s) {
      this.staticImgUpload.push({
        url: item.img_s,
      });
    }
    if (item.img_d) {
      this.dynamicImgUpload.push({
        url: item.img_d,
      });
    }
    if (item.kind === 1) {
      item.kind1.cooling = Number((item.kind1.cooling / 60).toFixed(0));
    }
    this.showDialog = true;
  }

  async submitGiftSave() {
    if (this.staticImgUpload.length) {
      this.giftFormData.img_s = this.staticImgUpload[0].url;
    }
    if (this.dynamicImgUpload.length) {
      this.giftFormData.img_d = this.dynamicImgUpload[0].url;
    }
    console.log(JSON.stringify(this.giftFormData));
    let giftAction = createGift;
    if (this.giftFormData.id! > 0) {
      giftAction = updateGift;
    }
    if (this.giftFormData.kind === 1) {
      this.giftFormData.kind1.cooling *= 60;
    }
    giftAction(this.giftFormData).then((resp: any) => {
      if (resp.code === 0) {
        toast('礼物保存成功');
        this.getList();
        this.giftFormData = JSON.parse(this.empityModel);
        this.showDialog = false;
      } else {
        toast(resp.msg, 'error');
        this.showDialog = false;
      }
    });
  }

  async getList() {
    this.loading = true;
    try {
      const query = {
        page: this.page_query.page,
        size: this.page_query.page_size,
        ...this.searchInfo,
      };
      const res = await listGift(query);
      if (res && res.code == 0) {
        this.total = res.data.count;
        this.list = res.data.rows;
        this.loading = false;
      } else {
        toast(res.msg, 'error');
      }
    } catch (err) {
      this.loading = false;
      console.log(err);
    }
  }

  async upSort(row: any, sort: string) {
    let sortItem: iGiftSort = {
      id: row.id || -1,
      sort: sort,
      version: row.version || -1,
    };
    try {
      const res = await sortGift(sortItem);
      if (res && res.code == 0) {
        toast('调序成功');
        this.loading = false;
        this.getList();
      }
    } catch (err) {
      this.loading = false;
      if (err && err.code == 3) {
        this.getList();
      }
    }
  }
  mounted() {
    this.pageFn = this.getList;
    this.getList();
  }
}
